/**
 * Map swarm `withdraw` error codes (the `details.error` string) to a user
 * friendly message. The raw `details.message` from swarm is usually
 * generic ("Internal service fault"), so we look this map up first.
 */
export const WITHDRAWAL_ERRORS = {
  PendingWithdrawalRequests: 'You already have a pending withdrawal request. Please wait until it is processed before submitting a new one.',
};

/**
 * Resolves the best error message for a failed withdrawal response.
 *
 * Tries, in order:
 *   1. `details.error` mapped via WITHDRAWAL_ERRORS
 *   2. `details.Message` (legacy v2 shape)
 *   3. `details.message` (raw v1 shape)
 *   4. `details` itself when it's a string
 *   5. a generic fallback
 */
export const resolveWithdrawalError = (details) => {
  if (details?.error && WITHDRAWAL_ERRORS[details.error]) {
    return WITHDRAWAL_ERRORS[details.error];
  }

  if (details?.Message) return details.Message;
  if (details?.message) return details.message;
  if (typeof details === 'string') return details;

  return 'An error occurred while creating the cash withdrawal request.';
};
